import React from 'react';
import { styled } from 'linaria/react';
import { cx } from 'linaria';
import { ReactComponent as MapPinSvg } from '../../svg/MapPin.svg';
import { ReactComponent as NewMapPinSvg } from '../../svg/NewMapPin.svg';

import { theme } from '../Theme';

const MarkerContainer = styled('div')`
  position: relative;
  width: 24px;
  height: 29px;
  margin-right: 12px;

  svg {
    fill: ${theme.colors.white};

    path {
      stroke: #911827;
    }

    width: 100%;
    height: 100%;
  }
  &.active {
    svg {
      fill: #911827;
    }

    span {
      color: ${theme.colors.white};
    }
  }

  span {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 3px;
    right: 0;

    display: flex;
    justify-content: center;
    align-items: center;

    font-family: 'Source Sans Pro', sans-serif;
    font-size: 16px;
    line-height: 1;

    color: #911827;
  }
`;

export const StoreMarker = ({ nr, active, large, ...rest }) => (
  <MarkerContainer className={cx(active ? 'active' : null)} {...rest}>
    {active ? <MapPinSvg /> : <NewMapPinSvg />}
    {/* <span>{nr}</span> */}
  </MarkerContainer>
);
